var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 537,
    viewBox: "0 0 468 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M467.393 387.032V536.786L233.697 343.272L0 536.786V387.032L233.697 193.518L467.393 387.032Z",
    fill: "#00AEEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.698 193.514L324.109 268.391L467.394 149.754V0L233.698 193.514Z",
    fill: "#ED1846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000732422 149.754L143.237 268.391L233.697 193.514L0.000732422 0V149.754Z",
    fill: "#ED1846"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.64f627618ae6e725fae78ccf5a3ae934.svg";
export { ForwardRef as ReactComponent };